import { AvField, AvForm } from "availity-reactstrap-validation"
import React, { useEffect, useState } from "react"
import { MetaTags } from "react-meta-tags"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Label,
  Row,
} from "reactstrap"
import PropTypes from "prop-types"

// actions
import { getClientDetail, updateClient } from "store/actions"
import { get } from "helpers/api_methods"

const UpdateClient = () => {
  const dispatch = useDispatch()
  const params = useParams()
  const [categories, setCategories] = useState([])

  const { clientDetail } = useSelector(state => ({
    clientDetail: state.Clients.clientDetail,
  }))

  useEffect(() => {
    dispatch(getClientDetail(params.id))
    fetchCategories()
  }, [dispatch, params.id])

  const fetchCategories = async () => {
    try {
      const res = await get("/order/client-category/")
      if (Array.isArray(res)) {
        setCategories(res)
      } else if (res && res.results) {
        setCategories(res.results)
      }
    } catch (err) {
      console.error("Failed to fetch client categories", err)
    }
  }

  function handleValidSubmit(values) {
    const payload = {
      ...values,
      address: values.address_1 || values.address || clientDetail?.address || "",
    }
    dispatch(updateClient(payload, clientDetail.id))
    window.scroll(0, 0)
  }

  return (
    <>
      <MetaTags>
        <title>Update Client | Indtech </title>
      </MetaTags>

      <div className="page-content">
        <Container fluid>
          <div className="container-fluid">
            <Row>
              <Col xl="3"></Col>
              <Col lg={12}>
                <Card style={{ padding: "2rem" }}>
                  <CardBody>
                    <CardTitle className="h4 mb-4">Update Profile</CardTitle>

                    <AvForm
                      className="form-horizontal "
                      onValidSubmit={(e, v) => {
                        handleValidSubmit(v)
                      }}
                    >
                      <div className="row mb-4">
                        <Label
                          htmlFor="horizontal-username-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Name <span className="text-danger">*</span>
                        </Label>
                        <Col sm={9}>
                          <AvField
                            id="horizontal-username-Input"
                            className="filePathClass"
                            name="name"
                            type="text"
                            value={clientDetail?.name}
                            validate={{
                              required: { value: true },
                            }}
                          />
                        </Col>
                      </div>

                      <div className="row mb-4">
                        <Label
                          htmlFor="category-select"
                          className="col-sm-3 col-form-label"
                        >
                          Category <span className="text-danger">*</span>
                        </Label>
                        <Col sm={9}>
                          <AvField
                            type="select"
                            name="category"
                            id="category-select"
                            className="form-select"
                            value={clientDetail?.category}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: "Please select a category",
                              },
                            }}
                          >
                            <option value="">Select Category</option>
                            {categories.map(cat => (
                              <option key={cat.id} value={cat.id}>
                                {cat.name}
                              </option>
                            ))}
                          </AvField>
                        </Col>
                      </div>

                      <div className="row mb-4">
                        <Label
                          htmlFor="address1-input"
                          className="col-sm-3 col-form-label"
                        >
                          Address 1
                        </Label>
                        <Col sm={9}>
                          <AvField
                            id="address1-input"
                            name="address_1"
                            value={clientDetail?.address_1}
                            type="text"
                            placeholder="optional"
                          />
                        </Col>
                      </div>

                      <div className="row mb-4">
                        <Label
                          htmlFor="address2-input"
                          className="col-sm-3 col-form-label"
                        >
                          Address 2
                        </Label>
                        <Col sm={9}>
                          <AvField
                            id="address2-input"
                            name="address_2"
                            value={clientDetail?.address_2}
                            type="text"
                            placeholder="optional"
                          />
                        </Col>
                      </div>

                      <div className="row mb-4">
                        <Label
                          htmlFor="gst-input"
                          className="col-sm-3 col-form-label"
                        >
                          GST Number
                        </Label>
                        <Col sm={9}>
                          <AvField
                            id="gst-input"
                            name="gst_number"
                            value={clientDetail?.gst_number}
                            type="text"
                            placeholder="optional"
                          />
                        </Col>
                      </div>

                      <div className="row mb-4">
                        <Label
                          htmlFor="tel-input"
                          className="col-sm-3 col-form-label"
                        >
                          Phone
                        </Label>
                        <Col sm={9}>
                          <AvField
                            name="phone"
                            className="form-control"
                            id="tel-input"
                            value={clientDetail?.phone}
                            type="mobile"
                            placeholder="optional"
                            validate={{
                              minLength: {
                                value: 10,
                                errorMessage:
                                  "Your number must be 10 characters",
                              },
                              maxLength: {
                                value: 10,
                                errorMessage:
                                  "Your number must be 10 characters",
                              },
                            }}
                          />
                        </Col>
                      </div>

                      <div className="row mb-4">
                        <Label
                          htmlFor="horizontal-email-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Email
                        </Label>
                        <Col sm={9}>
                          <AvField
                            id="horizontal-email-Input"
                            name="email"
                            value={clientDetail?.email}
                            className="form-control"
                            type="email"
                            placeholder="optional"
                          />
                        </Col>
                      </div>

                      <div className="row mb-4">
                        <Label
                          htmlFor="horizontal-lastname-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Description
                        </Label>
                        <Col sm={9}>
                          <AvField
                            id="horizontal-lastname-Input"
                            name="description"
                            value={clientDetail?.description}
                            type="textarea"
                            placeholder="optional"
                          />
                        </Col>
                      </div>

                      <div className="row justify-content-end">
                        <Col sm={9}>
                          <div>
                            <Button
                              type="submit"
                              color="success"
                              className="w-md"
                            >
                              Update
                            </Button>
                          </div>
                        </Col>
                      </div>
                    </AvForm>
                  </CardBody>
                </Card>
              </Col>
              <Col xl="3"></Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  )
}

export default UpdateClient

UpdateClient.propTypes = {
  history: PropTypes.object,
}
